/*
 * av-artwork.js
 * ---------------------------------------------------------------------------
 * Vorschauleiste der Werkseite: Klick auf ein Vorschaubild tauscht die
 * Hauptabbildung. Kein Slider, keine Bibliothek — die Bilder liegen alle
 * schon im Markup, getauscht wird nur, welches sichtbar ist.
 *
 * Delegate auf dem Dokument, damit es auch nach einem Sektions-Neuaufbau
 * im Theme-Editor weiterläuft.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  function activate(root, index) {
    var views = root.querySelectorAll('[data-av-view]');
    var thumbs = root.querySelectorAll('[data-av-thumb]');
    for (var i = 0; i < views.length; i++) {
      views[i].hidden = String(i) !== String(index);
    }
    for (var j = 0; j < thumbs.length; j++) {
      var on = String(j) === String(index);
      thumbs[j].classList.toggle('is-active', on);
      thumbs[j].setAttribute('aria-current', on ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest ? event.target.closest('[data-av-thumb]') : null;
    if (!thumb) return;
    var root = thumb.closest('[data-av-artwork]');
    if (!root) return;
    event.preventDefault();
    activate(root, thumb.getAttribute('data-av-thumb'));
  });

  /* Tastatur: Pfeiltasten in der Leiste */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    var thumb = document.activeElement;
    if (!thumb || !thumb.matches || !thumb.matches('[data-av-thumb]')) return;
    var list = Array.prototype.slice.call(
      thumb.closest('[data-av-artwork]').querySelectorAll('[data-av-thumb]')
    );
    var next = list[list.indexOf(thumb) + (event.key === 'ArrowDown' ? 1 : -1)];
    if (!next) return;
    event.preventDefault();
    next.focus();
    next.click();
  });
})();

/* ---------------------------------------------------------------------------
 * Vollbild-Galerie
 *
 * Öffnet sich über die Hauptansicht, über „Alle Ansichten" und über den
 * Hinweis darunter. Beide Hinweise waren vorher nur Text — sie versprachen
 * etwas, das nicht passierte.
 *
 * Escape schließt, Pfeiltasten blättern, der Fokus geht beim Schließen
 * dorthin zurück, wo er geöffnet wurde.
 * -------------------------------------------------------------------------*/
(function () {
  'use strict';

  var opener = null;

  function items(lb) { return lb.querySelectorAll('[data-av-lb-item]'); }

  function show(lb, index) {
    var list = items(lb);
    if (!list.length) return;
    var i = ((index % list.length) + list.length) % list.length;
    for (var k = 0; k < list.length; k++) list[k].hidden = k !== i;
    lb.setAttribute('data-av-lb-index', String(i));
    var count = lb.querySelector('[data-av-lb-count]');
    if (count) count.textContent = i + 1 + ' / ' + list.length;
  }

  function currentIndex(root) {
    var views = root.querySelectorAll('[data-av-view]');
    for (var i = 0; i < views.length; i++) if (!views[i].hidden) return i;
    return 0;
  }

  function open(root, index) {
    var lb = root.querySelector('[data-av-lightbox]');
    if (!lb) return;
    opener = document.activeElement;
    show(lb, index);
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = lb.querySelector('[data-av-lb-close]');
    if (close) close.focus();
  }

  function close(lb) {
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  function step(lb, delta) {
    show(lb, parseInt(lb.getAttribute('data-av-lb-index'), 10) + delta);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var trigger = event.target.closest('[data-av-zoom]');
    if (trigger) {
      var root = trigger.closest('[data-av-artwork]');
      if (!root) return;
      event.preventDefault();
      var raw = trigger.getAttribute('data-av-zoom');
      open(root, raw === 'current' ? currentIndex(root) : parseInt(raw, 10) || 0);
      return;
    }

    var lb = event.target.closest('[data-av-lightbox]');
    if (!lb) return;
    if (event.target.closest('[data-av-lb-prev]')) { step(lb, -1); return; }
    if (event.target.closest('[data-av-lb-next]')) { step(lb, 1); return; }
    /* Klick auf die Fläche neben dem Bild schließt — wie in jeder Galerie. */
    if (event.target.closest('[data-av-lb-close]') || !event.target.closest('.av-aw-lb__item')) close(lb);
  });

  /* Die Hauptansicht ist ein div mit role=button — Enter und Leertaste
     müssen deshalb von Hand ausgelöst werden. */
  document.addEventListener('keydown', function (event) {
    var view = event.target.closest ? event.target.closest('[data-av-view][data-av-zoom]') : null;
    if (view && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      view.click();
      return;
    }

    var lb = document.querySelector('[data-av-lightbox]:not([hidden])');
    if (!lb) return;
    if (event.key === 'Escape') { event.preventDefault(); close(lb); }
    else if (event.key === 'ArrowRight') { event.preventDefault(); step(lb, 1); }
    else if (event.key === 'ArrowLeft') { event.preventDefault(); step(lb, -1); }
  });
})();

/* ---------- Varianten-Auswahl (Rahmen) -------------------- */
/* Der Preis über der Auswahl zeigte immer die Startvariante —
   bei „Weiß · 570 €“ stand oben weiter 500 €. Beim Wechsel
   werden Preis und ?variant= in der Adresse nachgezogen. */
(function () {
  document.querySelectorAll('[data-av-variant-select]').forEach(function (select) {
    var scope = select.closest('.av-aw__form') ? select.closest('.av-aw__form').parentNode : document;
    var price = scope.querySelector('[data-av-price]');
    var form = select.form;
    var hidden = form ? form.querySelector('input[type="hidden"][name="id"]') : null;

    function sync(updateUrl) {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      if (price && option.getAttribute('data-price')) price.textContent = option.getAttribute('data-price');
      if (hidden) hidden.value = option.value;
      if (updateUrl) try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(null, '', url.toString());
      } catch (error) { /* Adresse bleibt */ }
    }

    select.addEventListener('change', function () { sync(true); });
    /* Der Browser stellt nach Zurück/Neuladen die alte Auswahl
       wieder her — dann sofort angleichen. */
    sync(false);
  });
})();

/*
 * Ratenzahlung: die eigene Klarna-Zeile öffnet Klarnas offizielle
 * Erklärung. Dafür wird der unsichtbar mitgeladene Klarna-Baustein
 * angeklickt (offenes Shadow-DOM, Teil „osm-cta").
 */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var row = event.target.closest ? event.target.closest('[data-av-klarna]') : null;
    if (!row) return;
    var scope = row.parentElement || document;
    var placement = scope.querySelector('klarna-placement') || document.querySelector('klarna-placement');
    var root = placement && placement.shadowRoot;
    var cta = root && (root.querySelector('[part~="osm-cta"]') || root.querySelector('button, a'));
    if (cta) cta.click();
  });
})();
